import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { permission } from 'src/app/core/Constants/permissions';
import { statusOptions } from 'src/app/core/Constants/static';
import { ColumnSortObj } from 'src/app/core/Models/interfaces/columnSort';
import { Pagination } from 'src/app/core/Models/interfaces/pagination';
import { AllRolesFilter } from 'src/app/core/Models/interfaces/payloads/allRoles';
import { Role } from 'src/app/core/Models/interfaces/role';
import { UserService } from 'src/app/core/Services/user.service';
import { UserManagementService } from 'src/app/features/user-management/service/user-management.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.css']
})
export class RoleListComponent implements OnInit {
  private page_limit = 10;
  private sortParams = '';
  
  public page_no = 1;
  public fetchingInProgress = false;
  public totalCount = 10;
  public roleList:Role[]=[];
  public filterationForm!:FormGroup;
  public openAddEdit:boolean=false;
  public isEdit:boolean=false;
  public viewDetails:boolean=false;
  public rolePermission=permission.role;
  public selectedItem!:Role;
  public statusOptions=statusOptions;

  public columnSort: ColumnSortObj = {
    name: {
      sortType: 'ascending',
    },
    id: {
      sortType: 'ascending',
    },
  };

  constructor(
    private toasterandLoader: ToasterService,
    private userManage:UserManagementService,
    private userService:UserService
  ) { }

  private createFilterForm():void{
    this.filterationForm=new FormGroup({
      role:new FormControl(),
      isActive:new FormControl({ label: 'Active', value: 1 })
    })
  }

  private applyFilter():void{
    this.toasterandLoader.isLoaderEnable(true);
    const payLoad:AllRolesFilter = {
      per_page: this.page_limit,
      page: this.page_no,
      sort: this.sortParams,
      role: this.filterationForm?.value?.role || '',
      isActive:this.filterationForm?.value?.isActive.value || ''
    }
    this.userManage.getAllRoles(payLoad).subscribe({
      next: (res) => {
        this.roleList = res?.data?.data
        this.totalCount = res?.data?.total
        this.fetchingInProgress = false;
        this.toasterandLoader.isLoaderEnable(false);
      },
      error: (err) => {
        this.fetchingInProgress = false;
        this.toasterandLoader.isLoaderEnable(false);
      }
    })
  }

  public ngOnInit():void {
    this.createFilterForm();
  }

  public editRole(role:Role):void{
    this.isEdit=true;
    this.openAddEdit=true;
    this.selectedItem=role;
  }

  public currentPageDetail(event: Pagination): void {
    if (event) {
      this.page_no = event.button_no;
      this.page_limit = event.item_per_page;
    }
    // this.isScrollIntoViewNeeded();
    this.applyFilter();
  }

  public sortColumn(colName: string): void {
    for (const key in this.columnSort) {
      if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
        if (key == colName) {
          this.columnSort[colName].clicked = true;
          this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
          this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
          this.page_no = 1;
          this.applyFilter();
        } else {
          this.columnSort[key].sortType = 'ascending';
        }
      }
    }
  }

  public filterApply():void{
    this.page_no = 1;
    this.applyFilter()
  }

  public resetFilter(): void {
    this.filterationForm.reset();
    this.filterationForm.controls['isActive'].setValue({ label: 'Active', value: 1 })
    this.page_no = 1;
    this.applyFilter();
  }

  public closeAddEdit(event:boolean):void{
    this.isEdit=false;
    this.openAddEdit=false;
    this.applyFilter();
  }
  
  public checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }

  public viewRoleDetails(role:Role){
    this.viewDetails=true;
    this.selectedItem=role;

  }



}
